(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-playlist/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/youtube-playlist/assets/javascripts/init.js');

'use strict';

svs.components.youtube_playlist.init = () => {
  const expandableElements = document.querySelectorAll('[data-expandable]');
  const expandableButtons = document.querySelectorAll('[data-expand-button]');
  function checkForOverflow() {
    expandableElements.forEach(expandableElement => {
      if (!expandableElement || expandableElement.classList.contains('expanded')) {
        return;
      }
      const expandableText = expandableElement.querySelector('[data-expand-text]');
      const isOverflowing = expandableText.scrollHeight > expandableText.clientHeight;
      expandableElement.dataset.overflow = isOverflowing;
    });
  }
  function setExpandButtonText(button) {
    const expandableElement = button.closest('[data-expandable]');
    const isExpanded = expandableElement.classList.contains('expanded');
    button.innerText = isExpanded ? 'Visa mindre' : 'Läs mer';
  }
  function toggleText(event) {
    const button = event.target;
    const expandableElement = button.closest('[data-expandable]');
    expandableElement.classList.toggle('expanded');
    setExpandButtonText(button);
  }
  expandableButtons.forEach(button => {
    button.addEventListener('click', toggleText);
    setExpandButtonText(button);
  });
  checkForOverflow();
  function showMoreVideos() {
    var _videoPlaylists$datas;
    const showMoreBtn = document.querySelector('.js-show-more-btn');
    const showMoreLink = document.querySelector('.js-show-more-link');
    const hiddenVideos = document.querySelectorAll('.js-youtube-playlist_playlist-item.hidden');
    const videoPlaylistsContainer = document.querySelector('.js-youtube-playlist-container');
    const videoPlaylists = videoPlaylistsContainer === null || videoPlaylistsContainer === void 0 ? void 0 : videoPlaylistsContainer.querySelector('.js-youtube-playlist_video-list');
    const playlistItems = (videoPlaylists === null || videoPlaylists === void 0 ? void 0 : videoPlaylists.childElementCount) + 1;
    const availableVideos = (videoPlaylists === null || videoPlaylists === void 0 || (_videoPlaylists$datas = videoPlaylists.dataset) === null || _videoPlaylists$datas === void 0 ? void 0 : _videoPlaylists$datas.availableVideos) || [];
    if (!showMoreBtn || !hiddenVideos.length) {
      return;
    }
    showMoreBtn.addEventListener('click', () => {
      hiddenVideos.forEach(video => {
        video.classList.remove('hidden');
      });
      if (availableVideos > playlistItems) {
        showMoreLink.parentElement.style.display = 'block';
      }
      showMoreBtn.parentElement.style.display = 'none';
    });
  }
  showMoreVideos();
};

 })(window);